package uz.ferro.erp.feature.order.model

import kotlinx.serialization.Serializable
import uz.ferro.erp.feature.property.model.Property

@Serializable
data class OrderProperty(
    val id: Long? = null,
    val property: Property? = null,
    val sort: Int? = null
)